
        <div>
            <div class="row">
                <div class="col-sm-10 offset-sm-1 text-center">
                    <h1 class="display-3" style="text-align: center; font-size: x-large; font-weight: bold;">{{'Step2-Welcome.TranslationSection.text1' | translate}}</h1>
                 
                      
                        <form id="welcome1" (ngSubmit)="step2Submitted()"  novalidate class="justify-content-left">

                          <div class="text-align:center">
                     <!--Changes Md-->
                            <div class="form-group text-align:left" >
                              {{'Step2-Welcome.TranslationSection.text2' | translate}}
                          </div><br>
                    <!--
                                              <div class="form-group text-align:left" >
                          2. Exams
                      </div>

                      <div class="form-group text-align:left">
                        3. References
                    </div>

                    -->
                          <div class="form-group text-align:left">
                            1. {{'Step2-Welcome.TranslationSection.text3' | translate}}
                        </div>


		</div>
                                                       
                      <br>


              
                        <div class="row" >
                          <footer class="footernote" >
                            <b>{{'Step2-Welcome.TranslationSection.text4' | translate}}</b> {{'Step2-Welcome.TranslationSection.text5' | translate}} {{'Step2-Welcome.TranslationSection.text6' | translate}}<b><u>{{'Step2-Welcome.TranslationSection.text7' | translate}}</u> </b>
                            {{'Step2-Welcome.TranslationSection.text8' | translate}}
                            </footer>
                          
                        
                        </div>

                   <div class="form-row" style="height:20px;"></div>
                   

                  

                      <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-4">
                            <div class="form-group">
                              <button type="button" (click)="decreasePage()" class="btn btn-create"  matStepperPrevious><i className="ace-icon fa fa-arrow-left"></i>{{'Step2-Welcome.TranslationSection.text9' | translate}}</button>
                            </div>
                        </div>
                    
                        <div class="col-lg-5 col-md-5 col-sm-5">
                            <div class="form-group">
                              <button type="submit"  class="btn btn-success">{{'Step2-Welcome.TranslationSection.text10' | translate}} &nbsp;</button> &nbsp;
                            </div>
                        </div>
                    </div>


                          
                        </form>              
                </div>
            </div>
        </div>






  
  